<template>
  <b-container fluid class="mt-4 p-0">
    <div class="list-card d-flex align-items-center justify-content-center">
      <div class="p-4 w-100">
        <!-- First row -->
        <div class="list-row d-flex align-items-center justify-content-between px-3 mb-3 border-left-gold">
          <div class="d-flex align-items-center gap-2">
            <div class="dot gold"></div>
            <div class="line navy-long"></div>
          </div>
          <div class="line navy-short"></div>
        </div>

        <!-- Second row -->
        <div class="list-row d-flex align-items-center justify-content-between px-3">
          <div class="d-flex align-items-center gap-2">
            <div class="dot muted"></div>
            <div class="line navy-long-muted"></div>
          </div>
          <div class="line navy-short-muted"></div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "ListPlaceholder"
};
</script>

<style scoped>
/* Card wrapper */
.list-card {
  height: 12rem; /* ~ h-48 */
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #f1f1f1;
}

body.dark .list-card {
  background-color: #0b1c2d;
  border-color: rgba(201, 162, 77, 0.5);
}

/* Row container */
.list-row {
  height: 40px; /* h-10 */
  background-color: rgba(11, 28, 45, 0.05);
}

body.dark .list-row {
  background-color: rgba(201, 162, 77, 0.05);
}

/* Left border for first row */
.border-left-gold {
  border-left: 2px solid #c9a24d;
}

/* Dot sizes */
.dot {
  width: 6px; /* size-1.5 */
  height: 6px;
  border-radius: 50%;
}

.dot.gold {
  background-color: #c9a24d;
}

.dot.muted {
  background-color: rgba(11, 28, 45, 0.2);
}

body.dark .dot.muted {
  background-color: rgba(201, 162, 77, 0.2);
}

/* Lines */
.line {
  height: 4px; /* h-1 */
}

.navy-long {
  width: 80px; /* w-20 */
  background-color: rgba(11, 28, 45, 0.4);
}

.navy-short {
  width: 24px; /* w-6 */
  background-color: rgba(11, 28, 45, 0.4);
}

.navy-long-muted {
  width: 96px; /* w-24 */
  background-color: rgba(11, 28, 45, 0.2);
}

.navy-short-muted {
  width: 24px; /* w-6 */
  background-color: rgba(11, 28, 45, 0.2);
}

body.dark .line {
  background-color: rgba(201, 162, 77, 0.4);
}

body.dark .navy-long-muted,
body.dark .navy-short-muted {
  background-color: rgba(201, 162, 77, 0.2);
}
</style>
